import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { DensityPage } from "@/features/quality/components/density/density-page";

const search = z.object({
  tab: z.enum(["raw", "condition", "review", "reviewed"]).default("raw"),
  q: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
});

/** Density data (seedtrac QCS p174–176, QCM p221; user, 2026-10-16). */
export const Route = createFileRoute("/_app/quality/density/")({
  validateSearch: search,
  beforeLoad: () => {
    const { can } = useAuth.getState();
    if (!can("qc.density") && !can("qc.density_edit"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DensityPage
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
